import React from 'react';
import Setting from "../../image/Setting.svg";
import Alert from "../../image/Alert.svg";
import Metabase from './Metabase';
import { Link, NavLink } from 'react-router-dom';
import Popup from 'reactjs-popup';
import { Button, DialogContent, DialogContentText } from '@mui/material';
import MailIcon from '../../Components/MainIcons/MailIcon';

const Dashboard = (props) => {


  return (<div style={{height:"100%",width:"100%"}}>
    <div>
    <div className="EvidenceTaskNavbar">
        <div>
          <span className="EvidenceTitle">Dashboard</span>
        </div>
        <MailIcon state={props.state}/>
        </div>
    </div>
    <Metabase/>
    </div>

  )
}

export default Dashboard;